import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';

export const wallDashboardSecretGuard: CanActivateFn &
  CanActivateChildFn = async (route) => {
  const router = inject(Router);
  const hasAccess = !!route.queryParamMap.get('key');

  return hasAccess ? true : router.createUrlTree(['/no-access']);
};
